import { AutoritaEsproprianteDTO } from "./autorita-espropriante-dto";
import { DatiOperaDTO } from "./dati-opera-dto";
import { ParticellaDTO } from "./particella-dto";

export class CostituzioneDepositoEsproprioDTO {
	autoritaEspropriante: AutoritaEsproprianteDTO;
	generalContractor: boolean;
	particelle: Array<ParticellaDTO>;
	datiOpera: DatiOperaDTO;
	irreperibile: boolean;
	codiceRegione: string;
}
